// extracted by mini-css-extract-plugin
export var mobileItems = "header-module--mobileItems--5699b";
export var phoneText = "header-module--phoneText--0425f";